import _ from 'lodash'
/**
 * Sets up "nested collection" relationship, where a parent Backbone.Model's property
 * is represented by a nested Backbone.Collection. For example, Chart has a series
 * attribute, which is then nested as its own Collection.
 *
 * See nest-model for further explanation, as it is the same concept.
 */
var nestCollection = function (opt) {
	new Tracker(opt)
}

function Tracker (opt) {
	this.parent = opt.parent
	this.parentAttribute = opt.parentAttribute
	this.children = opt.children

	_.bindAll(this, 'onChange', 'onParentChange')

	this.listen()
}

_.extend(Tracker.prototype, {
	listen: function () {
		this.children.on('change remove add reset', this.onChange)
		this.children.listenTo(this.parent, 'change:' + this.parentAttribute, this.onParentChange)
	},

	stopListening: function (){
		this.children.off('change remove add reset', this.onChange)
		this.children.stopListening(this.parent, 'change:' + this.parentAttribute, this.onParentChange)
	},

	onChange: function () {
		this.stopListening()
		this.parent.set(this.parentAttribute, this.children.toJSON())
		this.listen()
	},

	onParentChange: function () {
		this.stopListening()

		var update = _.map(this.parent.get(this.parentAttribute), function (childFromParent) {
			var childId = this.children.modelId(childFromParent)
			if (!childId) {
				return childFromParent
			}

			var childFromCollection = this.children.get(childId)

			if (!childFromCollection) {
				return childFromParent
			}

			// See nest-model.js for explanation of why we're doing this. Basically so
			// child model properties are unset correctly.
			var nulledOut = _(childFromCollection.attributes).keys().map(function (key) {
			  return [key, null]
			}).fromPairs().value()

			return _.extend(nulledOut, childFromParent)
		}.bind(this))

		this.children.set(update)

		this.listen()
	}
})

export default nestCollection

nestCollection.__filename__ = 'components/nest-collection.js'
